module.exports = __webpack_public_path__ + "static/media/landing-make.f7caab65.jpg";